import { ENDPOINTS } from "@/constants/api/endpoints";
import { useApiQuery } from "../../hooks/use-api-query";
import { queryKeys } from "../../query-keys";
import { CityRefrencesResp } from "@/types/city";

export const useCities = () => {
  return useApiQuery<CityRefrencesResp>(
    queryKeys.references.cities,
    ENDPOINTS.REFERENCES.CITIES,
    {},
    {
      staleTime: 30 * 60 * 1000, // 30 minutes
      gcTime: 60 * 60 * 1000, // 1 hour
      refetchOnMount: false, // Use prefetched data, don't refetch on mount
      refetchOnWindowFocus: false, // Don't refetch on window focus for reference data
    }
  );
};
